const resolveCurrentProperty = (customProps: any, properties: any, name: any, dash: string = '--' ):string => {
  let finalClass = ''
  if (!Array.isArray(properties)) return finalClass

  const propKeys = Object.keys(customProps)

  // Check user props inside Component Schema
  for (let i = 0, lgt = propKeys.length; i < lgt; i += 1) {
    const currentPropName = propKeys[i]
    if (customProps[currentPropName] === true) {
      if (
        properties.find(
          (prop) => prop === currentPropName || prop.title === currentPropName
        )
      ) {
        finalClass += `mdn-${name}${dash}${currentPropName} `
      }
    }
  }

  // If user props does not match Component Schema, find default value:
  if (!finalClass) {
    const defaultValue = properties.find((prop) => prop.isDefault === true)
    if (defaultValue) finalClass += `mdn-${name}${dash}${defaultValue.title} `
  }

  return finalClass
}

const resolveProps = (props: any, config: any, name: any, dash: string = '--') => {
  let finalClassName = `mdn-${name} `

  finalClassName += resolveCurrentProperty(props, config.types, name, dash)
  finalClassName += resolveCurrentProperty(props, config.modifiers, name, dash)
  finalClassName += resolveCurrentProperty(props, config.states, name, dash)

  finalClassName += props.className || ''

  return finalClassName
}

const resolveFns = <Args extends readonly unknown[]>(
  ...fns: readonly (((...args: Args) => void) | undefined)[]
) => (...args: Args): void => fns.forEach((fn) => fn?.(...args));





export { resolveCurrentProperty, resolveFns }

export default resolveProps
